export const commercialPartner = {
    id: 'CommercialPartner',
    start: '2021-06-21',
    expiry: '2021-09-01',
    author: 'Max Duval (@mxdvl)',
    description: 'Some empty commercial partner test',
    audience: 0,
    audienceOffset: 0,
    successMeasure: 'n/a',
    audienceCriteria: 'n/a',
    showForSensitive: true,
    variants: [
        {
            id: 'variant',
            test: () => {
                // debugger;
            },
        },
    ],
    canRun: () => true,
};
